export class GoogleMapsWrapper {
  map: google.maps.Map;
  maps: any;
  initialized = false;

  constructor(map: google.maps.Map, maps: any) {
    this.map = map;
    this.maps = maps;
    this.initialized = true;
  }

  geocode(location: google.maps.LatLng): Promise<google.maps.GeocoderResult[]> {
    const request = {
      location: location,
    };

    const { maps } = this;
    if (maps && maps.Geocoder && maps.places) {
      const service = new maps.Geocoder();

      return new Promise<google.maps.GeocoderResult[]>((resolve, reject) => {
        service.geocode(request, function (results, status) {
          if (status === maps.places.PlacesServiceStatus.OK) {
            resolve(results);
          } else {
            reject(maps.places.PlacesServiceStatus[status]);
          }
        });
      });
    }
    return Promise.reject('error while loading Google Maps API');
  }

  moveToLocation(lat, lng): void {
    const center = new google.maps.LatLng(lat, lng);
    this.map.panTo(center);
  }

  geocodePlaceId(placeId: string): Promise<google.maps.GeocoderResult[]> {
    const request = {
      placeId: placeId,
    };

    const { maps } = this;
    if (maps && maps.Geocoder && maps.places) {
      const service = new maps.Geocoder();

      return new Promise<google.maps.GeocoderResult[]>((resolve, reject) => {
        service.geocode(request, function (results, status) {
          if (status === maps.places.PlacesServiceStatus.OK) {
            resolve(results);
          } else {
            reject(maps.places.PlacesServiceStatus[status]);
          }
        });
      });
    }
    return Promise.reject('error while loading Google Maps API');
  }

  textSearch(keyword: string): Promise<google.maps.places.PlaceResult[]> {
    const request = {
      query: keyword,
      fields: ['formatted_address', 'name', 'geometry', 'place_id'],
    };

    const { map, maps } = this;

    if (maps && maps.places) {
      const service = new maps.places.PlacesService(map);

      return new Promise<google.maps.places.PlaceResult[]>((resolve, reject) => {
        service.textSearch(request, function (results: google.maps.places.PlaceResult[], status) {
          if (status === maps.places.PlacesServiceStatus.OK) {
            resolve(results);
          } else {
            reject(maps.places.PlacesServiceStatus[status]);
          }
        });
      });
    }
    return Promise.reject('error while loading Google Maps API');
  }

  autocompleteSearch(keyword: string): Promise<google.maps.places.AutocompletePrediction[]> {
    const request = {
      input: keyword,
    };

    const { maps } = this;

    if (maps && maps.places) {
      const service = new maps.places.AutocompleteService();

      return new Promise<google.maps.places.AutocompletePrediction[]>((resolve, reject) => {
        service.getQueryPredictions(request, function (results, status) {
          resolve(results);
          if (status === maps.places.PlacesServiceStatus.OK) {
            resolve(results);
          } else {
            reject(maps.places.PlacesServiceStatus[status]);
          }
        });
      });
    }
    return Promise.reject('error while loading Google Maps API');
  }

  getUpBounds() {
    const { map } = this;
    if (!map) return;

    const bounds = map.getBounds();
    return { ne: bounds?.getNorthEast(), sw: bounds?.getSouthWest() };
  }

  addMarker(center, callback) {
    const { map, maps } = this;

    if (!maps || !map) return;

    const mark: any = new maps.Marker({
      position: center,
      map,
    });

    callback(center, this.getUpBounds());
    return mark;
  }
}

export function getState(address: any[]): string {
  let state = '';
  address.forEach((a: any) => {
    if (a.types.includes('administrative_area_level_1')) {
      state = a.short_name;
    }
  });
  return state;
}

export function getCity(address: any[]): string {
  let city = '';
  address.forEach((a: any) => {
    if (a.types.includes('administrative_area_level_2') && city === '') {
      city = a.long_name;
    }
    if (a.types.includes('locality')) {
      city = a.long_name;
    }
    if (a.types.includes('administrative_area_level_1')) {
      city = a.long_name;
    }
  });
  return city;
}

export function getCountry(address: any[]): string {
  let country = '';
  address.forEach((a: any) => {
    if (a.types.includes('country')) {
      country = a.long_name;
    }
  });
  return country;
}

export function getCountryCode(address: any[]): string {
  let code = '';
  address.forEach((a: any) => {
    if (a.types.includes('country')) {
      code = a.short_name;
    }
  });
  return code;
}
